import { FC } from 'react';
import {
  FilterSection,
  ColumnDateFilter,
  ColumnMultiSelectFilter,
} from 'components/data-table';
import type { DifferentialScenarioFacets } from './types';
import styles from './differential-scenarios-filters.module.scss';

interface DifferentialScenariosFiltersProps {
  facets: DifferentialScenarioFacets | undefined;
}

const toOptions = (items: { id: string; value: string }[] | undefined) =>
  (items ?? []).map((item) => ({ value: item.id, label: item.value }));

/**
 * Filter sidebar for the Differential Scenarios list page.
 * @param {DifferentialScenariosFiltersProps} props - The component props
 * @return {JSX.Element} The filter sidebar
 */
const DifferentialScenariosFilters: FC<DifferentialScenariosFiltersProps> = ({
  facets,
}) => (
  <div className={styles.filtersWrapper}>
    <FilterSection title="Date Filters">
      <ColumnDateFilter columnId="effectiveDate" label="Effective Date" />
      <ColumnDateFilter columnId="createdAt" label="Created At" />
      <ColumnDateFilter columnId="updatedAt" label="Updated At" />
    </FilterSection>

    <FilterSection title="Details">
      <ColumnMultiSelectFilter
        columnId="createdBy"
        label="Created By"
        options={toOptions(facets?.createdByOptions)}
      />
    </FilterSection>
  </div>
);

export { DifferentialScenariosFilters };
